import Avatar, { type AvatarProps } from '@mui/material/Avatar';
import type { ReactNode } from 'react';

interface InitialsAvatarProps extends AvatarProps {
  initials: string;
  size?: number;
}

export function InitialsAvatar({
  initials,
  size = 36,
  sx,
  ...props
}: InitialsAvatarProps): ReactNode {
  return (
    <Avatar
      {...props}
      sx={[
        {
          width: size,
          height: size,
          flexShrink: 0,
          background: (theme) => theme.gradients.primary,
          color: 'common.white',
          fontSize: 13,
          fontWeight: 700,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {initials}
    </Avatar>
  );
}
